import React, { useState } from 'react'
import { ReactComponent as GlobeIcon } from 'assets/images/icons/globeIcon.svg'
import ReactSwitch from 'react-switch'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { getContents_action, getPrivateAndFavoriteContents_action, refreshOnSharing_action, toggleShareModal_action } from 'store/actions'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { ActionDropdown, colors, CopyLink, ModalForm, SharingGlobeDiv } from 'modules/app/styles'
import { CustomButton, EyeIcon, LoginInput } from 'modules/auth/styles'
import { createPageSharing_api, deletePageSharing_api, updatePageSharing_api } from 'store/apis'
import { generateGuestSlug, getTitle, handleApiError, logAmplitudeEvent, shareLink } from 'utils/helpers'
import { connect } from 'react-redux'
import { ButtonLoader, PageLoader } from 'utils/storageUtils'
import { toast } from 'react-toastify'
import { BsEye, BsEyeSlash } from 'react-icons/bs'

const GuestSharingModal = (props) => {
  const { page } = props
  const [state_page, set_state_page] = useState(page)
  const [show_copy_div, set_show_copy_div] = useState(page.guest_sharing && page.guest_sharing.is_accessible ? true : false)
  const [show_password_div, set_show_password_div] = useState(page.guest_sharing && page.guest_sharing.password ? true : false)
  const [password, set_password] = useState('')
  const [is_loading, set_is_loading] = useState(false)
  const [is_updating, set_is_updating] = useState(false)
  const [hasError, set_hasError] = useState(null)
  const [passwordVisible, setPasswordVisible] = useState(false)

  const showCopyDiv = async () => {
    set_show_copy_div(!show_copy_div)
    if (!state_page.guest_sharing || !state_page.guest_sharing.is_accessible) {
      set_is_loading(true)
      const result = await createPageSharing_api(state_page.uuid)
      set_state_page((value) => ({ ...value, guest_sharing: result }))
    } else {
      set_is_loading(true)
      await deletePageSharing_api(state_page.guest_sharing.sharing_id)
      set_state_page((value) => ({ ...value, guest_sharing: { ...value.guest_sharing, is_accessible: false } }))
    }
    set_is_loading(false)
    if (state_page.category?.uuid) {
      props.getContents({ type: state_page.type, category_uuid: state_page.category?.uuid })
    } else {
      props.getPrivateAndFavoriteContents({ type: state_page.type })
    }
    props.refreshOnSharing(true)
  }

  const showPasswordDiv = async () => {
    set_show_password_div(!show_password_div)
    try {
      if (state_page.guest_sharing.password) {
        await updatePageSharing_api(state_page.guest_sharing.sharing_id, { password: null, _method: 'patch' })
        toast.success('Password removed!')
        if (state_page.category?.uuid) {
          props.getContents({ type: state_page.type, category_uuid: state_page.category?.uuid })
        } else {
          props.getPrivateAndFavoriteContents({ type: state_page.type })
        }
        props.refreshOnSharing(true)
      }
    } catch (e) {
      handleApiError(e)
    }
  }

  const closeModal = (e) => {
    e && e.preventDefault()
    props.toggleShareModal(false)
  }

  const updateShareModal = async (e) => {
    e.preventDefault()
    try {
      if (password.trim() !== '') {
        set_is_updating(true)
        await updatePageSharing_api(state_page.guest_sharing.sharing_id, { password: password, _method: 'patch' })
        toast.success('Password updated successfully.')
        set_is_updating(false)
        if (state_page.category?.uuid) {
          props.getContents({ category_uuid: state_page.category?.uuid, type: state_page.type })
        } else {
          props.getPrivateAndFavoriteContents({ type: state_page.type })
        }
        props.refreshOnSharing(true)
        props.toggleShareModal(false)
      } else {
        set_hasError('Enter password')
      }
    } catch (e) {
      set_is_updating(false)
      handleApiError(e)
    }
  }

  const triggerCopyTextHandler = async (e) => {
    const ActionButtons = e.target.closest('.action-buttons')
    const BUTTONS = [ActionButtons.querySelector('.copyButton')]
    ActionButtons.classList.add('show')
    BUTTONS[0].querySelector('span').textContent = 'COPIED'
    BUTTONS.forEach((button) => {
      button.classList.toggle('black')
      button.classList.toggle('green')
    })
    setTimeout(() => {
      BUTTONS[0].querySelector('span').textContent = 'COPY'
      BUTTONS.forEach((button) => {
        button.classList.toggle('black')
        button.classList.toggle('green')
      })
      ActionButtons.classList.remove('show')
    }, 1500)
    e.preventDefault()
  }

  return (
    <Modal zIndex={props.fullScreenStatus ? '300000000000' : ''} centered fade={false} isOpen size='md' toggle={closeModal}>
      <ModalForm onSubmit={(e) => e.preventDefault()} autoComplete='off'>
        <ModalBody className='pt-5 modal-body'>
          <div className='d-flex justify-content-between'>
            <div className='title'> Share </div>
            <a
              href='/'
              className='modal-close'
              onClick={(e) => {
                e.preventDefault()
                props.toggleShareModal(false)
              }}>
              <CloseIcon />
            </a>
          </div>

          <div className='d-flex  justify-content-between mb-3 align-items-center'>
            <SharingGlobeDiv>
              <GlobeIcon />
              <div className='header'>
                <p className='head'>Get sharable public link</p>
                <p className='sub-title'>Publish and share with anyone</p>
              </div>
            </SharingGlobeDiv>
            <ReactSwitch
              onChange={showCopyDiv}
              checked={show_copy_div}
              className={`reactSwitch ${show_copy_div ? 'on' : 'off'}`}
              offColor='#fff'
              onColor={colors['main-blue']}
              offHandleColor={colors['light-blue-300']}
              onHandleColor='#fff'
              width={48}
              height={24}
              handleDiameter={16}
              uncheckedIcon={false}
              checkedIcon={false}
            />
          </div>
          {is_loading ? (
            <PageLoader />
          ) : (
            state_page.guest_sharing &&
            state_page.guest_sharing.is_accessible && (
              <CopyLink>
                <div className='copy'>
                  <p>{`${process.env.REACT_APP_BASE_URL}guest/page/${generateGuestSlug(getTitle(state_page.title), state_page.guest_sharing.sharing_id)}`}</p>
                  <ActionDropdown className={`action-buttons`}>
                    <Button
                      tabIndex={'0'}
                      type='button'
                      className='copyButton rounded-pill black btn-sm px-4 py-1 ml-3 shadow-none align-self-center'
                      onClick={async (e) => {
                        shareLink(getTitle(state_page.title), state_page.guest_sharing.sharing_id)
                        logAmplitudeEvent('Web: Copied a response to clipboard')
                        triggerCopyTextHandler(e, 'html')
                      }}>
                      <span style={{ transform: 'translateY(1.1px)' }}>COPY</span>
                    </Button>
                  </ActionDropdown>
                </div>
                <div className='password-toggle'>
                  <p>Require password</p>
                  <ReactSwitch
                    onChange={showPasswordDiv}
                    checked={show_password_div}
                    className={`reactSwitch ${show_password_div ? 'on' : 'off'}`}
                    offColor='#fff'
                    onColor={colors['main-blue']}
                    offHandleColor={colors['light-blue-300']}
                    onHandleColor='#fff'
                    width={48}
                    height={24}
                    handleDiameter={16}
                    uncheckedIcon={false}
                    checkedIcon={false}
                  />
                </div>
              </CopyLink>
            )
          )}

          {show_password_div && (
            <div>
              <input type='password' style={{ display: 'none' }} />
              <LoginInput
                type={passwordVisible ? 'text' : 'password'}
                id='password'
                className={`login-input ${password.trim() !== '' ? 'has-value' : ''}`}
                value={password}
                onChange={(e) => set_password(e.target.value)}
                placeholder='Password'
              />
              {password.trim() !== '' && (
                <EyeIcon style={{ top: '280px', right: '40px' }} onClick={() => setPasswordVisible(!passwordVisible)}>
                  {!passwordVisible ? <BsEye size={20} /> : <BsEyeSlash size={20} />}
                </EyeIcon>
              )}
              {hasError && <div className='error-message w-100'> {hasError} </div>}
            </div>
          )}
        </ModalBody>
        {show_password_div && (
          <ModalFooter className='d-flex justify-content-center align-items-center'>
            <CustomButton className='black mx-3 shadow-none align-self-center' onClick={updateShareModal}>
              Update
              {is_updating && <ButtonLoader />}
            </CustomButton>
            <a
              href='/'
              className='font-weight-bold'
              onClick={(e) => {
                e.preventDefault()
                props.toggleShareModal(false)
              }}>
              Cancel
            </a>
          </ModalFooter>
        )}
      </ModalForm>
    </Modal>
  )
}
const mapStateToProps = (state) => ({
  page: state.contents.sharingPage,
  fullScreenStatus: state.contents.isFullScreen
})
const mapDispatchToProps = (dispatch) => ({
  getPrivateAndFavoriteContents: (filters) => dispatch(getPrivateAndFavoriteContents_action(filters)),
  getContents: (filters) => dispatch(getContents_action(filters)),
  toggleShareModal: (status) => dispatch(toggleShareModal_action(status)),
  refreshOnSharing: (status) => dispatch(refreshOnSharing_action(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(GuestSharingModal)
